// Copyright (c) 2016 Deere & Company

export default Object.freeze({
  A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: "Esiste gi\xE0 un layout con tale nome",
  ACCEPT: "Accetta",
  ACCEPT_ALL: "Accetta tutti",
  ACCEPT_REJECT_TRANSFER_PENDING: "Approvazione in sospeso",
  ACCEPTED: "Accettato",
  ACCOUNT: "Conto",
  ACCOUNT_ADDRESS: "Indirizzo del Conto",
  ACCOUNT_COUNTRY: "Paese del Conto",
  ACCOUNT_END: "Fine account",
  ACCOUNT_NAME: "Nome del Conto",
  ACCOUNT_NUMBER: "Numero del Conto",
  ACCOUNT_NUMBER_REQUIRED: "Il No. del Conto \xE9 necessario",
  ACCOUNTS: "Conto",
  ACCUMULATED_DAYS_ON_RENT: "Giorni accumulati noleggio",
  ACCUMULATED_DAYS_RENTED: "Giorni accumulati noleggio",
  ACTIONS: "Azioni",
  ACTIVE_WARRANTY: "Garanzia attiva",
  ACTIVE_WARRANTY_CLICK_FOR_DETAIL: "Garanzia attiva (clicca i dettagli)",
  ACTUAL_AUDIT: "Controllo effettivo",
  ACTUAL_AUDIT_DATE: "Data controllo attuale",
  ACTUAL_COURIER_NAME: "Nome corriere corrente",
  ACTUAL_HOURS: "Ore effettive",
  ADD_CLAIM: "Aggiungi reclamo",
  ADD_CLAIMS: "Aggiungi reclami",
  ADD_OPTION: "Aggiungi Opzione",
  ADD_REP: "Riparazione Supplementare",
  ADD_TO_AUDIT: "Aggiungi al controllo",
  ADDITIONAL: "Supplementare",
  ADDITIONAL_COMMENTS: "Commenti aggiuntivi",
  ADDITIONAL_REPAIR: "Riparazione Supplementare",
  ADDITIVE: "Supplemento",
  ADDRESS: "Indirizzo",
  ADDRESS_LINE1: "Indirizzo 1",
  ADDRESS_LINE1_REQUIRED: "Riga indirizzo 1 necessaria",
  ADDRESS_LINE2: "Indirizzo 2",
  ADJ_CLM: "Modifica reclamo",
  ADJUST_CLAIM: "Modifica reclamo",
  ADJUSTED_HOURS: "Ore regolate",
  ADJUSTED_QUANTITY: "Quantit\xE0 adeguata",
  ADJUSTMENT_TYPE: "Tipo di modifica",
  ADVANCED_CLAIM_SUMMARY: "Riepilogo avanzato reclami",
  AFTER_DELIVERY_INSPECTION: "ISPEZIONE DOPO LA CONSEGNA",
  AGENCY_NAME: "Nome dell'Agenzia",
  ALL: "Tutto",
  ALL_ACCOUNTS: "Tutti I conti",
  ALL_CLAIMS: "Tutti i reclami",
  ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: "Tutti i reclami sono soggetti a revisione (per ulteriori informazioni, vedere JD WAM 110.08)",
  ALL_CLAIMS_TAB: "Tutti i reclami ({count, number})",
  ALL_PART_REQUESTS: "Tutte le richiesta ricambi",
  ALL_PART_REQUESTS_WITH_COUNT: "Tutte le richiesta ricambi ({count})",
  ALL_PARTS_RETURNED: "Tutte le Parti Ritornate",
  AMOUNT: "Importo",
  AMOUNT_1: "Importo 1",
  AMOUNT_2: "Importo 2",
  AMOUNT_3: "Importo 3",
  AMOUNT_OF_USE: "Ore d\u2019uso",
  AMOUNT_OF_USE_HISTORY_WITH_COUNT: "Cronologia del periodo di utilizzo ({count})",
  AMOUNT_OF_USE_IS_REQUIRED: "Il periodo di utilizzo \xE8 obbligatorio",
  AMOUNT_OF_USE_REQUIRED: "\xC8 obbligatorio indicare il periodo di utilizzo",
  AMOUNT_OF_USE_UNITS_REQUIRED: "\xC8 obbligatorio indicare le unit\xE0 del periodo di utilizzo",
  AMOUNT_RECORDED: "Importo registrato",
  AMOUNT_TO_BE_DEBITED: "Importo da addebitare",
  APLYPIP: "Trasferire il PIP",
  APPLICATION: "Applicazione",
  APPLICATION_IS_REQUIRED: "L'applicazione \xE8 obbligatoria",
  APPLY: "Applica",
  APPLY_TRAVEL: "Applicare il  viaggio",
  APPROVAL_DEALER_COMMENTS: "Approvazione Commenti del Concessionario",
  APPROVAL_DETAILS: "Dettagli approvazione",
  APPROVAL_LEVELS: "Livelli di approvazione",
  APPROVAL_REMARKS: "Note di approvazione",
  APPROVAL_STATUS: "Stato approvazione",
  APPROVE: "Approva",
  APPROVE_LABOR_RATE: "Approva tariffa manodopera",
  APPROVE_MACHINE_STATUS_UPDATE: "Approva aggiornamento dello stato della macchina",
  APPROVE_PIP_CODE_REQUEST: "Approva richiesta codice programma PIP",
  APPROVE_SPECIAL_ALLOWANCE_CLAIM: "Approva reclamo garanzia speciale concordata",
  APPROVED: "Approvato",
  APPROVED_CORE_VALUE: "Valore nucleo approvato",
  APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: "La data di approvazione non pu\xF2 precedere la data d'installazione",
  APPROVED_DIAGNOSTIC_AMOUNT: "Importo diagnostico approvato",
  APPROVED_DIAGNOSTIC_HOURS: "Ore diagnostiche approvate",
  APPROVED_IS_REQUIRED: "L'approvazione \xE8 obbligatoria",
  APPROVED_LABOR_ADDITIVE: "Supplementi approvati per la manodopera",
  APPROVED_LABOR_AMOUNT: "Importo manodopera approvato",
  APPROVED_LABOR_HOURS: "Ore manodopera approvate",
  APPROVED_LABOR_TOTAL: "Totale manodopera approvata",
  APPROVED_ON_SHELF_COST: "Costo giacenze magazzino approvato",
  APPROVED_OTHER_CREDITS: "Altri crediti approvati",
  APPROVED_PARTS: "Parti approvate",
  APPROVED_PARTS_ADDITIVE: "Ricambi aggiunti approvati",
  APPROVED_PARTS_TOTAL: "Totale parti approvato",
  APPROVED_REJECTED: "Approvato/rifiutato",
  APPROVED_REPAIR_AMOUNT: "Importo di riparazione approvato",
  APPROVED_REPAIR_HOURS: "Ore di riparazione approvate",
  APPROVED_TAXES_TOTAL: "Totale imposta approvato",
  APPROVED_TRAVEL_TOTAL: "Totale viaggio-approvato",
  APPROVER: "Approvatore",
  ASCENDING: "Ascendente",
  ATTACHMENTS: "Allegati",
  AUDIT_NUMBER: "Numero del Controllo",
  AUDIT_PLANNED: "Data del controllo programmata",
  AUDIT_REQUIREMENT: "Requisiti del Controllo",
  AUDIT_RESULTS: "Risultati del Controllo",
  AUDIT_STATUS: "Stato del Controllo",
  AUDIT_SUBMITTED_SUCCESSFULLY: "Invio controllo riuscito",
  AUDIT_SUMMARY: "Riepilogo controllo",
  AUDIT_TYPE: "Tipo di controllo",
  AUDITS: "Controllo effettivo",
  AUDITS_DUE_WITH_COUNT: "{countToDisplay} controllo da eseguire",
  AUDITS_DUE_WITHIN_30_DAYS: "{countToDisplay} {count, plural, one {controllo} other {controlli}} da eseguire entro 30 giorni",
  AUDITS_PAST_DUE_WITH_COUNT: "{countToDisplay} {count, plural, one {controllo} other {controlli}} scaduti",
  AUTHORIZATION_NUMBER: "No. dell'autorizzazione",
  AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: "Inoltro automatico dal sistema aziendale del concessionario",
  AVAILABLE: "Disponibile",
  AVAILABLE_COLUMNS: "Colonne Disponibile",
  AVERAGE_DIAGNOSTICS_HOURS: "Ore di diagnostica medie",
  AVERAGE_LUG_HEIGHT: "Altezza media dei talloni",
  AVERAGE_LUG_HEIGHT_IS_REQUIRED: "L'altezza media dei talloni \xE8 obbligatoria",
  AVERAGE_REPAIR_HOURS: "Ore di riparazione medie",
  AVERAGE_REPLACEMENT_HOURS: "Ore di sostituzione medie",
  AVERAGE_TECH_PAY_RATE: "Tariffa di pagamento tecnica media",
  BACK: "Indietro",
  BACK_TO_AUDIT: "Torna alla pagina degli controlli",
  BASE_MACHINE: "Macchina Base",
  BASE_MACHINE_IMPLEMENTS: "Attrezzi macchina base",
  BASE_MACHINE_PIN: "PIN macchina base",
  BASIC_WARRANTY_ENDS: "La garanzia di base \xE8 termina",
  BASIC_WARRANTY_ESTIMATOR: "Preventivo sulla garanzia di base",
  BASIC_WARRANTY_STARTS: "La garanzia di base inizia",
  BASIS_FOR_SETTLEMENT: "Basi per L'Accordo",
  BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: "Basi per L'Accordo / Commenti Audit",
  BASIS_FOR_SETTLEMENT_IS_REQUIRED: "Le basi per l'accordo sono obbligatorie",
  BATTERY: "Batterie",
  BEGIN_DATE: "Data d'Inizio",
  BRANCH: "Sede",
  BUILT: "Costruito",
  BUSINESS_END: "Business End",
  CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE: "\xC8 possibile rimettere la macchina in servizio?",
  CANCEL: "Cancella",
  CERTIFIED_LETTER_SENT: "Lettera raccomandata inviata",
  CGST: "CGST",
  CHANGE_RESPONSIBLE_DEALER: "Cambiare il concessionario responsabile",
  CHANGE_STATUS: "Cambiare lo stato",
  CHANGE_STATUS_FOR: "Modifica lo stato del {pin}",
  CHANGED: "Modificato",
  CHANGED_BY: "Cambiato da",
  CHANGED_ON: "Cambiato su",
  CHINESE: "Cinese",
  CITY: "Citt\xE0",
  CITY_REQUIRED: "Citt\xE0 richiesta",
  CLAIM: "Reclamo",
  CLAIM_COUNT_WITH_PARENTHESIS: "({countToDisplay} {count, plural, one {Reclamo} other {Reclami}})",
  CLAIM_DEBIT: "Addebito reclamo",
  CLAIM_DETAILS: "Dettagli sul reclamo",
  CLAIM_DRAFT: "BOZZA",
  CLAIM_HISTORY: "Storia dei reclami \u2013 ultimi 24 mesi.",
  CLAIM_HISTORY_WITH_COUNT: "Storia dei reclami \u2013 ultimi 24 mesi. ({count})",
  CLAIM_NUMBER: "No. Del Reclamo",
  CLAIM_RECOVER_PERCENTAGE: "({percentage}%)",
  CLAIM_SEARCH: "Ricerca reclamo",
  CLAIM_STATUS: "Stato del reclamo",
  CLAIM_TYPE: "Tipo di Reclamo",
  CLAIM_TYPES: "Tipi di reclamo",
  CLAIM_UPDATED_SUCCESSFULLY: "Reclamo aggiornato correttamente",
  CLAIM_VALUE: "Valore del reclamo",
  CLAIM_VALUE_DETAILS: "Dettagli valore reclamo",
  CLAIM_WITH_NUMBER: "Reclamo {claimNumber}",
  CLAIMS: "Reclami",
  CLAIMS_IN_PROGRESS: "Reclami in processo",
  CLAIMS_IN_PROGRESS_WITH_COUNT: "Reclami in processo ({count})",
  CLAIMS_OVERVIEW: "Panoramica reclami",
  CLAIMS_OVERVIEW_TAB: "Panoramica reclami ({count})",
  CLAIMS_WITH_COUNT: "{count} Reclami",
  CLICK_FOR_DETAILS: "(clicca  dettagli)",
  CLICK_TO_VIEW_ALL: "Clicca per visualizzare tutto",
  CLOSE: "Chiudi",
  CLOSED_PART_REQUESTS: "Richieste di parte chiuse",
  CLOSING: "Chiusura",
  CLOSING_ACCOUNT: "Chiusura account",
  CLOSING_ACCOUNT_WITH_COUNT: "Conto di chiusura ({count})",
  CODE: "Codice",
  COLLAPSE_ALL: "Comprimi tutto",
  COMMENT: "Commento",
  COMMENTS: "Commenti",
  COMMENTS_IS_REQUIRED: "I commenti sono obbligatori",
  COMMENTS_TO_DEALER: "Commenti del Concessionario",
  COMMON_LABOR_TYPES_WARNING: "Non tutti i tipi di manodopera disponibili per i conti selezionati",
  COMPANY: "Societ\xE0",
  COMPANY_CONTRIBUTION: "Contribuzione dell'Azienda",
  COMPANY_CONTRIBUTION_IS_REQUIRED: "Il contributo aziendale \xE8 obbligatorio",
  COMPLAINT_CAUSE: "Qual' \xE8 la causa della lamentela?",
  COMPLAINT_CAUSE_IS_REQUIRED: "La causa della lamentela \xE8 richiesta",
  COMPLAINT_CORRECTION: "Come \xE8 stato corretta la lamentela?",
  COMPLAINT_CORRECTION_IS_REQUIRED: "\xC8 necessario indicare la correzione della lamentela",
  COMPLETE: "Completare",
  COMPLETED: "Completato",
  COMPLETED_BY: "Completato Da",
  COMPLETED_DATE: "Data completamento",
  COMPLETED_IN_LAST_24_MONTHS: "Completati negli ultimi 24 mesi",
  COMPLETION_STATUS: "Stato di completamento",
  COMPONENT: "Componete",
  COMPONENT_SERIAL_NUMBER: "Componente No. di Serie",
  COMPONENT_SUCCESSFULLY_UPDATED: "Aggiornamento del componente riuscito",
  COMPONENTS: "Componenti",
  CONFIRM: "Conferma",
  CONFIRM_ADDITIONAL_REPAIR: "Volete aggiungere una riparazione ?",
  CONFIRM_ADJUST_CLAIM: "Volete modificare questo reclamo?",
  CONFIRM_CLOSING_ACCOUNT: "Accettare questo trasferimento?",
  CONFIRM_COPY_CLAIM: "Volete copiare questo reclamo?",
  CONFIRM_DELETE_ATTACHMENT: "Sei sicuro di voler eliminare il file allegato?",
  CONFIRM_DELETE_CLAIM: "Volete eliminare questo reclamo?",
  CONFIRM_DELETE_REGISTRATION: "Volete eliminare questa registrazione?",
  CONFIRM_EDIT_CLAIM: "Volete modificare questo reclamo?",
  CONFIRM_RECONCILE_CLAIM: "Volete riconciliare questo reclamo?",
  CONFIRM_RESEND_XML: "Reinviare XML? Permetta 24-48 ore di visibilit\xE0.",
  CONFIRM_SKIP_AUDIT: "Volete salta questo controllo?",
  CONFIRM_UNDO_REGISTRATION: "Annullare la registrazione?",
  CONTACTED: "Contattato",
  CONTAINS: "Contiene",
  CONTRACT_NUMBER: "Numero di contratto",
  CONTRACT_PURCHASED: "Contratto acquistato",
  CONTRACT_TYPE: "Tipo di contratto",
  COPY_CLAIM: "Copia reclamo",
  CORE: "Informazioni dettagliate",
  CORE_VALUE: "Valore del Nucleo",
  COUNTRY: "Stato",
  COUNTRY_REQUIRED: "Paese richiesto",
  COURIER_ACCOUNT_NUMBER: "Numero Conto corriere",
  COURIER_NAME: "Nomedel Corriere",
  COVERAGE_DECISION: "Decisione di copertura",
  COVERAGE_TYPE: "Tipo di copertura",
  CRDMEM: "Nota Accredito",
  CREATE: "Creato",
  CREATE_CLAIM: "Crea il reclamo",
  CREATE_LAYOUT: "Crea Layout",
  CREATE_NON_TRACKED_PIN_HELP_TEXT: "Prima di poter presentare un reclamo su questo prodotto, \xE8 necessario fornire alcune informazioni importanti",
  CREATE_PIP_CLAIM: "Crea reclamo PIP",
  CREATE_PIP_CLAIMS: "Crea reclami PIP",
  CREATE_PRODUCT_RECORD: "Crea record prodotto",
  CREATE_REQUEST: "Crea richiesta",
  CREATE_TRANSFER_PENDING: "Trasferimento in sospeso",
  CREATE_TRANSFER_SERVICE_UNAVAILABLE: "Servizio creazione  trasferimenti non disponibile",
  CREATED: "Creato",
  CREATED_BY: "Creato da",
  CREATED_DATE: "Data creata",
  CREATED_ON: "Creato il",
  CREATION_DATE: "Data della creazione",
  CREDIT_MEMO: "Nota di credito",
  CREDIT_MEMO_DATE: "Data della Nota di Credito",
  CREDIT_MEMO_ISSUE_DATE: "Nota di credito emessa",
  CREDIT_MEMO_NUMBER: "Numero nota di credito",
  CREDIT_MEMO_PROCESS_DATE: "Nota di credito elaborata",
  CREDIT_MEMO_SELECTED: "Nota di credito selezionata",
  CREDIT_MEMOS: "Note di credito",
  CRITERIA: "Criteri",
  CRT: "Creato",
  CSV_SEPARATOR: "Separatore CSV",
  CURRENCY: "Valuta",
  CURRENT: "Corrente",
  CURRENT_ACCOUNT: "Conto Corrente",
  CURRENT_AMOUNT_OF_USE: "Ore d\u2019uso correnti",
  CURRENT_CUSTOMER: "Cliente corrente",
  CURRENT_DEALER: "Concessionario  attuale",
  CURRENT_DEALER_DISTANCE: "Distanza corrente del dealer",
  CURRENT_DEALER_LAST_SERVICE_DATE: "Data ultima assistenza dealer corrente",
  CURRENT_DEALER_LOCATION: "Attuale sede concessionario",
  CURRENT_HOURS: "Ore attuali",
  CURRENT_QUANTITY: "Quantit\xE0 attuale",
  CURRENT_RESPONSIBLE_DEALER: "Attuale dealer responsabile",
  CURRENT_VALUES: "Valori correnti",
  CURRENTLY_ON_RENT: "Attualmente a noleggio",
  CUSTOM_RANGE: "Personalizza Intervalli",
  CUSTOM_VALUES: "Valori personalizzati",
  CUSTOMER: "Cliente",
  CUSTOMER_CONTRIBUTION: "Contribuzione del Cliente",
  CUSTOMER_CONTRIBUTION_IS_REQUIRED: "Il contributo del cliente \xE8 obbligatorio",
  CUSTOMER_CREATED_SUCCESSFULLY: "Creazione cliente riuscita",
  CUSTOMER_DETAILS: "Dettagli del Cliente",
  CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: "Aggiornamento dettagli cliente riuscito",
  CUSTOMER_INFORMATION: "Informazioni per il cliente",
  CUSTOMER_INFORMATION_IS_REQUIRED: "Le informazioni del cliente sono richieste.",
  CUSTOMER_INVALID: "Cliente non valido",
  CUSTOMER_NAME: "Nome del cliente",
  CUSTOMER_NAME_IS_REQUIRED: "Le informazioni del cliente sono richieste.",
  CUSTOMER_NOT_FOUND: "Cliente non trovato",
  CUSTOMER_PROFILE: "Profilo Cliente",
  CUSTOMER_REQUIRED: "\xC8 necessario indicare il cliente",
  CUSTOMER_RESOLUTION: "Risoluzione del cliente",
  CUSTOMER_RESOLUTION_IS_REQUIRED: "La risoluzione del cliente \xE8 obbligatoria",
  CUSTOMER_SEARCH: "Ricerca del Cliente",
  CUSTOMER_UPDATED_SUCCESSFULLY: "Aggiornamento cliente riuscito",
  DAMAGED_MACHINES_HELP_TEXT: "Per le macchine danneggiate, la garanzia viene automaticamente sospesa fino alla revisione e approvazione del presente modulo da parte del TCSM. Le macchine danneggiate risultano idonee ai soli PIP Obbligatorioe Sicurezza.",
  DATE: "Data",
  DATE_FORMAT: "Data del Formato",
  DATE_ISSUED: "Data emessa",
  DATE_OF_CERTIFIED_LETTER: "Data della lettera raccomandata",
  DATE_OF_EVENT_CAUSING_DAMAGE: "Data dell'episodio che ha provocato il danno",
  DATE_OF_LAST_PERSONAL_CONTACT: "Data della ultima persona contattata",
  DATE_RECALLED_PART_WAS_SHIPPED_SENT: "La Data in cui la Parte Richiamata fu Spedita/Mandata",
  DATE_REFUSED: "Data del rifiuto",
  DATE_SUBMITTED: "Data di invio",
  DAYS_FROM_REGISTRATION: "Giorni dalla registrazione",
  DAYS_LEFT: "Giorni rimanenti",
  DAYS_LEFT_WITH_COUNT: "{daysToDisplay} {days, plural, one {giorno rimanente} other {giorni rimanenti}}",
  DAYS_ON_RENT: "Giorni Noleggio",
  DAYS_REMAINING: "Giorni Rimanenti",
  DAYS_REMAINING_WITH_COUNT: "{daysToDisplay} {days, plural, one {giorno rimanente} other {giorni rimanenti}}",
  DAYS_TO_DISPLAY: "Giorni da visualizzare",
  DBS: "DBS",
  DEALER: "Concessionario",
  DEALER_ACCOUNT: "Conto rivenditore",
  DEALER_ACCOUNT_IS_REQUIRED: "Il conto del concessionario \xE8 obbligatorio",
  DEALER_ACCOUNTS: "Clienti del Conc.",
  DEALER_CITY: "Citt\xE1 del Concessionario",
  DEALER_COMMENTS: "Commenti del Concessionario",
  DEALER_CONTRIBUTION: "Contribuzione del Concessionario",
  DEALER_CONTRIBUTION_IS_REQUIRED: "Il contributo del concessionario \xE8 obbligatorio",
  DEALER_HIERARCHY_ACCOUNT: "{account} ({industryIndicator})",
  DEALER_INVOICE_NUMBER: "Numero della fattura concessionario",
  DEALER_INVOICE_UPDATED: "Reclamo del Concessionario aggiornato",
  DEALER_INVOICE_UPDATES: "Fattura concessionario",
  DEALER_INVOICES: "Fatture concessionario",
  DEALER_LOCATION: "Localit\xE0 del Concessionario",
  DEALER_LOCATION_FILTER: "Filtra Localit\xE0",
  DEALER_LOCATION_IS_REQUIRED: "La sede del concessionario \xE8 obbligatoria",
  DEALER_LOCATIONS: "Localit\xE0 del concessionario",
  DEALER_NAME: "Nome del Concessionario",
  DEALER_PHONE: "No. Telephonico del Concessionario",
  DEALER_POSTAL_CODE: "CAP",
  DEALER_RECOMMENDATIONS: "Suggerimenti per i dealer",
  DEALER_RECOMMENDATIONS_TAB: "Suggerimenti per i dealer ({count})",
  DEALER_REVIEW_REQUEST_SUCCESSFULLY: "Recensione del dealer completata",
  DEALER_SEARCH: "Ricerca concessionario",
  DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: "Inserire nome, citt\xE0 o conto per cercare i concessionari",
  DEALER_STATE: "Provincia/Stato del Concessionario",
  DEALER_SUBMISSION_WITH_CURRENCY: "Invio concessionario ({currency})",
  DEALER_TRANSFER_HISTORY: "La storia di trasferimento del Concessionario",
  DEALER_TRANSFER_REQUEST_SUCCESSFULLY: "Richiesta di trasferimento del dealer in coda completata",
  DEALER_WARRANTY: "Garanzia del concessionaro",
  DEALERS: "Concessionari",
  DEALERSHIP: "Concessionaria",
  DEBIT: "Addebito",
  DEBIT_AMOUNT: "Importo addebito",
  DEBIT_FOR_CLAIM_NUMBER: "Addebito per {claimNumber}",
  DEBIT_REQUIRED: "Addebito richiesto",
  DEBIT_REQUIRED_STATUS: "Stato addebito richiesto",
  DEBIT_SUBMITTED_SUCCESSFULLY: "Invio addebito riuscito",
  DEBIT_TYPE: "Tipo di debito",
  DEBITED: "Addebitati",
  DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: "Gli addebiti per questo reclamo devono essere completati manualmente attraverso il processo addebiti",
  DECIMAL_FORMAT: "Formato decimale",
  DECISION_UPDATED: "Decisione aggiornata",
  DECLINE: "Rifiuta",
  DEDUCTIBLE: "Deducibile",
  DEERE_REMARKS: "Osservazioni di John Deere",
  DEFAULT_WARRANTY: "Garanzia predefinita",
  DEL: "Cancella",
  DELETE: "Cancella",
  DELETE_ATTACHMENT: "Elimina allegato",
  DELETE_CLAIM: "Cancella il  reclamo",
  DELETE_REGISTRATION: "Cancella la registrazione",
  DELETE_REGISTRATION_SUCCESS: "La registrazione \xE8 stata cancellata con successo",
  DELETED: "Cancellato",
  DELETED_BY: "Cancellato da",
  DELIVERED: "Consegnato",
  DELIVERED_IS_REQUIRED: "La data di consegna \xE8 richiesta",
  DELIVERY_DATE: "Data di Consegna",
  DELIVERY_DATE_REQUIRED: "Data di consegna \xE9 richiesta",
  DELIVERY_DATES: "Date di consegna",
  DELIVERY_NO_DOCUMENTS: "Consegna senza documenti",
  DEMO_RENTAL_BEGIN_DATE: "Dimostrazione/Noleggio Data Iniziale",
  DEMO_RENTAL_CHOOSE_DEALERS_STATUS: "Seleziona concessionari e stato",
  DEMO_RENTAL_END_DATE: "Dimostrazione/Noleggio Data Finale",
  DEMO_RENTAL_HISTORY: "Dimostrazione precedenti noleggio",
  DENY: "Rifiuto",
  DENY_MACHINE_STATUS_UPDATE: "Rifiuto aggiornamento  stato della macchina",
  DENY_PIP_CODE_REQUEST: "Rifiuto richiesta codice programma PIP",
  DESCENDING: "Discendente",
  DESCRIPTION: "Descrizione",
  DESCRIPTION_OF_DAMAGE: "Descrizione del danno",
  DESCRIPTION_OF_EVENT_CAUSING_DAMAGE: "Descrizione dell'episodio che ha provocato il danno",
  DESELECT_ALL: "Deseleziona tutto",
  DETAILS: "Dettagli",
  DIAGNOSTICS_COVERED: "Copertura diagnostica",
  DIS_VSR: "Visualizza  Messaggi",
  DISPLAY: "Visualizza",
  DISPLAY_CLAIM: "Visualizza reclamo",
  DISPLAY_CREDIT_MEMO: "Visualizza nota di accredito",
  DISPLAY_FORMAT: "Formato di visualizzazione",
  DISPLAY_PRODUCT: "Visualizza prodotto",
  DISPLAY_TAG: "Visualizza etichetta",
  DISTANCE: "Distanza",
  DISTANCE_FROM_CURRENT_DEALER: "Distanza dal dealer corrente",
  DISTANCE_FROM_POTENTIAL_DEALER: "Distanza da potenziali dealer",
  DIVISION: "Divisione",
  DIVISION_SUMMARY: "Riepilogo divisione",
  DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: "Salvare le modifiche?",
  DOES_NOT_CONTAIN: "Non contiene",
  DOWNLOAD_TO_EXCEL: "Scarica in Excel",
  DOWNTIME: "Tempo di fermo",
  DOWNTIME_IS_REQUIRED: "\xC8 necessario indicare il tempo di fermo",
  DRAFT: "Salva come bozza",
  DTAC_CASE: "Caso DTAC",
  DTAC_CASE_NUMBER: "Numero caso DTAC",
  DTAC_SOLUTION: "Soluzione DTAC",
  DUE_DATE: "Data di scadenza",
  DUE_WITHIN_3_MONTHS: "Entro 3 mesi",
  DUPLICATE_PIN_PLATE: "Duplicazione della targhetta PIN",
  DUPLICATE_PIN_PLATE_REQUEST_UPDATED: "Richiesta duplicazione della targhetta PIN aggiornata",
  DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: "Richiesta duplicazione della targhetta PIN creata correttamente",
  DUPLICATE_PIN_PLATE_WITH_COUNT: "Richiesta duplicazione targhetta PIN ({count})",
  EDIT: "Modifica",
  EDIT_CUSTOMER: "Modifica cliente",
  EDIT_LAYOUT: "Modifica Layout",
  EDIT_WITH_PARENTHESES: "(Modifica)",
  EFFECTIVE: "Con validit\xE0",
  EFFECTIVE_DATE: "Data effettiva",
  EMAIL: "Email",
  EMISSIONS_PART_SEARCH: "Ricerca parte per emissioni",
  END_DATE: "Data Finale",
  END_USE: "Uso finale",
  END_USE_CODE: "Codice Utente Finale",
  END_USE_CODE_REQUIRED: "\xC8 necessario inserire il codice utente finale",
  ENDS_WITH: "Termina con",
  ENGLISH: "Inglese",
  ENTER_A_NUMBER_BETWEEN_0_AND_1000: "Inserire un numero compreso tra 0 e 1000",
  ENTER_A_NUMBER_BETWEEN_0_AND_10000: "Inserire un numero compreso fra 0 e 10000",
  ENTER_A_NUMBER_FROM_1_TO_9999: "Inserire un numero compreso tra 1 e 9999",
  ENTER_A_PART_NUMBER: "Inserire un numero del ricambio",
  ENTER_COMMENTS_BEFORE_ACCEPTING: "Inserire i commenti prima di accettare",
  EQUALS: "Uguale a",
  ERROR: "ERRORE",
  ERROR_MESSAGE_TITLE: "Si \xE8 verificato un errore:",
  ERROR_MESSAGES: "Messaggio d'errore",
  ERROR_MESSAGES_TITLE: "Si sono verificati pi\xF9 errori",
  ERROR_NETWORK_ISSUES: "Un errore di rete impediva l'inserimento di alcuni dati - riprova",
  ERROR_NO_DATA_TO_EXPORT: "Nessun dato da esportare",
  ERROR_RETRIEVING_CUSTOMER_INFORMATION: "Errore durante il recupero delle informazioni sul cliente",
  ERROR_SAP: "Impossibile collegarsi al server. Se il problema persiste, utilizzare il link \"Contattaci\" per ottenere assistenza a risolvere il problema.",
  ERROR_SESSION: "La sessione \xE8 scaduta.  Aggiornare la pagina per effettuare nuovamente l'accesso.",
  ERROR_UNHANDLED: "Si \xE8 verificato un errore imprevisto nel sistema. Se il problema persiste, utilizzare la funzionalit\xE0 della \"Guida\" o il link \"Contattaci\" per ottenere assistenza a risolvere il problema.",
  ERROR_UPLOADING_FILE: "Il file non \xE8 stato aggiunto",
  ESTIMATED_BASIC_DATE: "Data base stimata",
  ESTIMATED_BASIC_DAYS: "Giorni base stimati",
  ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: "Le stime potrebbero non riflettere lo stato del Demo o le ore non ancora segnalate",
  EXCEEDS_DEMO_THRESHOLD: "Il periodo  Demo \xE8 superato",
  EXCHANGE_RATE: "Tasso di cambio",
  EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: "Excluded PINs are not included in this report.",
  EXECUTE: "Esegui",
  EXPAND_ALL: "Selezionare tutto",
  EXPECTED_FIRST_USE: "Primo utilizzo previsto",
  EXPIRATION_DATE: "Data scadenza",
  EXPIRED: "Scaduto",
  EXPIRED_PART_REQUESTS: "Richieste di parti scadute",
  EXPIRED_PIPS: "Programmi Scaduti",
  EXPIRES: "Scadenza",
  EXPIRING_SOON: "In scadenza",
  EXPORT: "Esporta",
  EXTENDED_WARRANTY: "Garanzia estesa",
  FACTORY: "FABBRICA",
  FACTORY_NAME: "Nome fabbrica",
  FAILED: "Avaria",
  FAILED_AREA: "Area avaria",
  FAILED_AREA_IS_REQUIRED: "L'area del'avaria  \xE8 obbligatoria",
  FAILED_DATE: "Data del'avaria",
  FAILED_DATE_IS_REQUIRED: "La data dell'avaria \xE8 obbligatoria",
  FAILED_MODE: "Modalit\xE0 avaria",
  FAILED_MODE_COMMENTS: "Commenti sulla modalit\xE0 dell'avaria",
  FAILED_PART: "Ricambio avariato",
  FAILED_PART_DESCRIPTION: "Descrizione ricambio avaraiato",
  FAILED_PART_IS_A_REMAN_PART: "Ricambio avariato \xE8 ReMan parte",
  FAILED_PART_IS_REQUIRED: "La parte avariata \xE8 obbligatoria",
  FAILED_PART_SERIAL: "Numero di serie parte avariata",
  FAILED_PART_SERIAL_IS_REQUIRED: "Il numero di serie della ricambio avariato \xE8 obbligatorio",
  FAILURE_DATE: "Data dell'avaria",
  FAILURE_INFORMATION: "Informazioni Avaria",
  FAILURE_MODE: "Codice dell'avaria",
  FAILURE_MODE_IS_REQUIRED: "La modalit\xE0 dell'avaria \xE8 obbligatoria",
  FAILURE_PART: "Ricambio guasto",
  FAILURE_PART_DESCRIPTION: "Descrizione della Parte Avariata",
  FAILURE_PART_IS_REQUIRED: "La parte avariata \xE8 obbligatoria",
  FAILURE_TO_RETURN_PARTS_WARNING: "La mancata restituzione delle parti richieste pu\xF2 comportare l'addebito.",
  FAVORITES: "Favoriti",
  FILE_NAME: "Nome file",
  FILE_SIZE_IS_TOO_BIG: "Le dimensioni del file sono eccessive (dimensioni massime 100 MB)",
  FILE_SIZE_IS_TOO_BIG_CSV: "Le dimensioni del file sono eccessive (dimensioni massime 1 MB)",
  FILE_UPLOAD_MESSAGE: "Rilasciarei file qui e cliccare su aggiungi file (dimensione massima 100 MB)",
  FILE_UPLOAD_MESSAGE_CSV: "Rilasciarei file qui e cliccare su aggiungi file (dimensione massima 1 MB)",
  FILE_UPLOAD_MESSAGE_IMAGE: "Rilasciarei immagini qui e cliccare su aggiungi immagini (dimensione massima 100 MB)",
  FILE_UPLOAD_MESSAGE_SINGLE: "Trascinare un file singolo qui o fare clic per aggiungere i file (dimensioni massime 100 MB)",
  FILE_UPLOAD_UNABLE_TO_READ: "Il sistema non \xE8 riuscito a leggere il file.  Confrontarlo con il modello e riprovare.",
  FILES: "File",
  FILTER_PLACEHOLDER: "Filtra risultati",
  FILTER_WITH_ELLIPSIS: "Filtra...",
  FILTERED_BY_COLUMN_ID: "Filtrato per {columnId}",
  FIND_CUSTOMER: "Trova cliente",
  FINNISH: "Finlandese",
  FIRST_MAINTENANCE: "PRIMA MANUTENZIONE",
  FIRST_NAME: "Nome",
  FIRST_NAME_IS_REQUIRED: "Il nome \xE8 obbligatorio",
  FIRST_SHIP_TO_LOCATION: "Prima  Localit\xE0 di spedizione",
  FIRST_USE: "Primo utilizzo",
  FISCAL_YEAR: "Anno fiscale",
  FLUID_SAMPLING_REQUIRED: "Esempio Liquido  richiesta",
  FORWARDED: "Innoltrato",
  FRENCH: "Francese",
  FROM: "Da",
  FRWRD: "Inoltra",
  FULL_DEBIT: "Addebito completo",
  GENERAL: "Generale",
  GERMAN: "Tedesco",
  GET_MAINTENANCE_PLANS: "Ottieni piani di manutenzione",
  GOODS_INSTALLATION_VAT: "IVA installazione prodotti",
  GRACE_PERIOD: "Periodo di Grazia",
  GREATER_THAN: "Maggiore di",
  GREATER_THAN_OR_EQUALS: "Maggiore di o uguale a",
  GROUP_COMPLETE: "Gruppo completo",
  GST_PERCENTAGE: "GST Percentuale",
  HISTORY_TO_DISPLAY: "Storia da Visualizzare (Giorni)",
  HOME: "Casa",
  HOUR_LIMIT: "Limite orario",
  HOURS: "Ore",
  HOURS_ON_RENT: "Ore a noleggio",
  HSN_SAC_CODE: "HSN/SAC Codice",
  IGST: "IGST",
  IMPLEMENTS: "Attrezzature",
  IN_RANGE: "Nell'intervallo",
  INCENTIVE: "Incentivo",
  INCENTIVE_PROGRAMS: "Programmi di incentivazione",
  INCLUDE_FULLY_COMPLETE: "Includi PIP completi",
  INDICATES_REQUIRED_FIELD: "Indica un campo obbligatorio",
  INFO_MESSAGE_TITLE: "\xC8 stata inviata una notifica di sistema",
  INFO_MESSAGES: "Messaggi d' informazione",
  INFO_MESSAGES_TITLE: "Sono state inviate notifiche di sistema multiple",
  INFO_REQUEST_STATUS_ERROR: "Le informazioni sono pronte per essere inviate con questa richiesta.",
  INFORMATION: "Informazione",
  INFORMATION_REQUEST: "Richiesta di informazioni",
  INFORMATION_REQUEST_STATUS: "Stato richiesta informazioni",
  INPUT_PIN: "Inserire No. Di Serie",
  INSPECTION: "Ispezione",
  INSTALLED_BY: "Installato da",
  INSTALLED_BY_IS_REQUIRED: "Installato da \xE8 richiesto",
  INTERNAL_DEERE_COMMENTS: "Commenti interni John Deere",
  INTERVAL_BEGINS: "Inizio intervallo",
  INTERVAL_ENDS: "Fine intervallo",
  INTERVAL_TYPE_DESCRIPTION: "Descrizione del tipo di intervallo",
  INVOICE_ACCOUNT: "Conto di fattura",
  INVOICE_DEALER: "Fattura del Concessionario",
  INVOICE_NUMBER: "No. della Fattura",
  INVOICE_REQUEST: "Richiesta fattura",
  INVOICE_SENT: "Fattura inviata",
  INVOICE_UPDATED_SUCCESSFULLY: "Fattura aggiornata con successo",
  INVOICED: "Fatturato",
  INVOICED_TO: "Fatturato a",
  IRC_PIN_MESSAGE: "Il cliente \xE8 un IRC ed ha diritto a tempo di viaggio e chilometraggio complementari per le prime 500 ore o 12 mesi di propriet\xE0 della macchina.",
  ISSUED: "Emesso",
  ITALIAN: "Italiano",
  ITEM: "Articolo",
  ITEM_NUMBER: "No. articolo",
  ITEM_NUMBER_IS_REQUIRED: "Il numero dell'articolo \xE8 obbligatorio",
  JDLINK_EXPIRES: "JDLink scade",
  JDP_COMMENTS: "Commenti",
  JDP_COMMENTS_IS_REQUIRED: "I commenti JDP sono richiesti",
  JDP_CUSTOMER_RESOLUTION: "JDP Risoluzione del Cliente",
  JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: "La risoluzione cliente JDP \xE8 obbligatoria",
  JDP_REASON: "JDP Ragione",
  JDP_REASON_IS_REQUIRED: "La ragione JDP \xE8 obbligatoria",
  LABOR: "Manodopera",
  LABOR_ADDITIVE: "Suppl. sulla Manodopera",
  LABOR_ADDITIVE_COMPLETION_DETAIL: "Dettagli aggiuntivi completamento manodopera",
  LABOR_ADDITIVE_PIPS: "Aggiuntivo di mandodopera PIP's",
  LABOR_ADDITIVE_TAB: "Aggiuntivo per la manodopera  ({count})",
  LABOR_ADJUSTMENT: "Regolazione della manodopera",
  LABOR_COMMENTS: "Commenti di Mano d'opera",
  LABOR_HOURS: "Mano D'opera",
  LABOR_ITEM_DETAILS: "Manodopera - {quantity} {unit} {description}",
  LABOR_RATE_APPROVED_SUCCESSFULLY: "Tariffa manodopera approvata correttamente",
  LABOR_RATE_CHANGE_SUBMITTED: "Modifica tariffa manodopera inviata",
  LABOR_RATE_CHANGES_WITH_COUNT: "Modifiche alle tariffe per la manodopera ({count})",
  LABOR_RATE_CONFIRM: "La tariffa richiesta \xE8 inferiore alla tariffa corrente. Volete inviare comunque la richiesta?",
  LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: "I tassi in rosso indicano un aumento di oltre il 10% rispetto all'aliquota esistente",
  LABOR_RATE_HISTORY: "Cronologia tariffe manodopera",
  LABOR_RATE_REJECTED_SUCCESSFULLY: "Tariffa manodopera rifiutata",
  LABOR_RATE_REQUESTS_STATUS: "Stato richieste tasso manodopera",
  LABOR_RATE_RETURNED_SUCCESSFULLY: "Tariffa manodopera restituita correttamente",
  LABOR_RATES: "Tariffe manodopera",
  LABOR_STATS: "Medie manodopera",
  LABOR_TOTAL: "Totale manodopera",
  LABOR_TYPE: "Tipo di Manodopera",
  LABOR_VALUE: "Valore manodopera",
  LABOR_WITH_COUNT: "Manodopera ({count})",
  LANGUAGE: "Lingua",
  LAST_LOCATION_FROM: "Ultima posizione da",
  LAST_NAME: "Cognome",
  LAST_NAME_IS_REQUIRED: "Il cognome \xE8 obbligatorio",
  LAST_PERSONAL_CONTACT: "Ultimo contatto personale",
  LAW_ENFORCEMENT_AGENCY_DETAILS: "Dettagli delle forze dell'ordine",
  LAYOUT_CREATED_SUCCESSFULLY: "Layout creato con successo",
  LAYOUT_DELETED_SUCCESSFULLY: "Layout eliminato con successo",
  LAYOUT_NAME: "Nome del layout",
  LAYOUT_UPDATED_SUCCESSFULLY: "Layout aggiornato con successo",
  LEAD_ACCOUNT: "Conto principale",
  LEAD_DEALER: "Concessionario principale",
  LESS_THAN: "Minore di",
  LESS_THAN_OR_EQUALS: "Minore di o uguale a",
  LICENSE_PLATE_NUMBER: "No. della Licenza sulla Targa",
  LIFETIME: "A Vita",
  LINE_ITEMS_EXPORT: "Esportazione di elementi pubblicitari",
  LIST: "Listino",
  LIST_TOTAL: "Elenco totale",
  LOCATION: "Localit\xE1",
  LOCATION_DUE: "Sede Controlli",
  LOCATIONS: "Sedi",
  LOCATIONS_WITH_COUNT: "Sedi ({count})",
  MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: "La macchina \xE8 gi\xE0 registrata per questo cliente",
  MACHINE_INFORMATION: "Informazioni macchine",
  MACHINE_MODEL_TYPE: "Modello/tipo di macchina",
  MACHINE_MODEL_TYPE_REQUIRED: "Modello/tipo macchina necessario",
  MACHINE_STATUS: "Stato della Macchina",
  MACHINE_STATUS_UPDATE_ACCEPTED: "Aggiornamento dello stato della macchina approvato",
  MACHINE_STATUS_UPDATE_DOCUMENT: "Documento di aggiornamento dello stato della macchina",
  MACHINE_STATUS_UPDATE_REJECTED: "Aggiornamento dello stato della macchina rifiutato",
  MACHINE_STATUS_UPDATES_WITH_COUNT: "Aggiornamenti dello stato delle macchine ({count})",
  MACHINE_TYPE: "Tipo di macchina",
  MACHINE_TYPE_IS_REQUIRED: "Il tipo di macchina \xE8 obbligatorio",
  MACHINE_USE: "Uso Macchina",
  MAILING_RECIPIENT: "Destinatario di posta (nome e cognome)",
  MAILING_RECIPIENT_REQUIRED: "Destinatario di mailing necessario",
  MAINTENANCE: "Manutenzione",
  MAINTENANCE_PLAN: "Programmi di manutenzione",
  MAINTENANCE_PLAN_INFO: "Informazioni sul piano di manutenzione",
  MARK_AS_REVIEW: "Contrassegna come revisionato",
  MARKETING_INCENTIVE: "Marketing - Incentivo",
  MARKETING_JD_PROMISE: "Marketing - JD promesse",
  MARKETING_MAINTENANCE_PLAN: "Marketing - Programma di manutenzione",
  MARKETING_MASS_CHANNEL_FOLLOWUP: "Marketing - Follow-up clienti di massa",
  MARKETING_MASS_CHANNEL_PDI: "Marketing - PDI clienti di massa",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP: "Cliente di massa - da seguire",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: "Promemoria: assicurarsi di contattare il proprio consulente legale per determinare le procedure relative agli utenti da non contattare all'interno del proprio paese e a livello regionale prima di implementare il programma di chiamate di follow-up post-vendita.",
  MASS_CHANNEL_PDI_CLAIM: "PDI clienti di massa",
  MASTER_WARRANTY_TYPE: "Tipo di garanzia principale",
  MATERIAL: "Numero materiale",
  MERCHANDISE: "Merce",
  MESSAGE: "Messaggio",
  MESSAGES: "Messaggi",
  METHOD_OF_CONTACT: "Metodo di contatto",
  METHOD_OF_CONTACT_IS_REQUIRED: "Il metodo di contatto \xE8 obbligatorio",
  METRIC: "Metrico",
  METRICS: "Metriche",
  MILEAGE_LIMIT: "Limite di chilometraggio",
  MOBILE_PHONE: "Telefono cellulare",
  MODEL: "Modello",
  MODEL_NUMBER: "Numero modello",
  MODIFIED: "Modificato",
  MONTH_TO_DATE: "Inizio mese a oggi",
  MORE: "Di Pi\xF9",
  MULTIPLE: "Multiplo",
  NAME: "Nome",
  NET: "Netto",
  NET_AMOUNT: "Importo netto",
  NET_AMOUNT_PAID: "Importo netto pagato",
  NET_TOTAL: "Totale netto",
  NEW: "Nuovo",
  NEW_ACCOUNT: "Nuovo account",
  NEW_CLAIM: "Nuovo reclamo",
  NEW_CLAIM_VALUE: "Nuovo valore del reclamo",
  NEW_CUSTOMER_REQUIRED: "\xC8 necessario il nuovo cliente",
  NEW_DEALER: "Nuovo concessionario",
  NEW_DEALER_DISTANCE: "Nuova distanza dealer",
  NEW_DEALER_LOCATION: "Nuova sede concessionario",
  NEW_LABOR_RATE: "Nuova tariffa manodopera",
  NEW_REQUEST_ENTER_RATES: "Nuova richiesta - Immettere le dosi",
  NEW_STATUS: "Nuovo stato",
  NEW_TRANSFER: "Nuovo trasferimento",
  NEW_TRANSFER_CREATED: "Nuovo trasferimento creato",
  NEW_VALUE: "Nuovo valore",
  NO: "No",
  NO_ACTIVE_WARRANTY: "Nessuna garanzia attiva",
  NO_AFFECTED_PINS: "Non sono presenti PIN sotto la responsabilit\xE0 della vostra concessionaria",
  NO_AUTHORITY_TO_ACCESS: "Non hai l'autorit\xE0 per accedere al JDWS. Gli utenti della rete di distribuzione possono consultare l'amministratore del profilo (DPA) per verificare l'autorit\xE0 e contattare il Supporto tecnico con una copia di questo errore",
  NO_CLAIMS: "Non sono presenti reclami.",
  NO_CUSTOMER_ASSOCIATED: "Nessun cliente associato",
  NO_CUSTOMER_SELECTED: "Nessun cliente selezionato",
  NO_DEALER_INVOICES: "Nessuna fattura concessionario",
  NO_DEALERS_MAPPED: "Non ci sono concessionari abbinati all'ID utente. Contattare l'amministratore di sistema.",
  NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE: "No (se non \xE8 possibile, allegare una documentazione fotografica)",
  NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: "Non ci sono informazioni disponibili per questo prodotto",
  NO_LOWERCASE: "No",
  NO_MATCHING_DEALERS: "Nessun concessionario corrisponde al testo del filtro.",
  NO_OPEN_PART_REQUESTS: "Nessuna richiesta di parte aperta",
  NO_OPEN_PIPS: "Nessun PIP aperto",
  NO_PARTS_RETURNED: "Nessuna Parte Ritornata",
  NO_PIP_PRODUCTS: "Non ci sono prodotti PIP.",
  NO_PRODUCT_FOUND: "Nessun prodotto trovato",
  NO_REQUIRED_ITEMS: "Nessun articolo richiesto.",
  NO_RESULTS: "Nessun risultato",
  NO_RESULTS_FOUND: "Nessun risultato trovato",
  NO_ROWS_TO_SHOW: "Nessuna fila da visualizzare",
  NO_SPECIAL_INSTRUCTIONS: "Non ci sono istruzioni speciali.",
  NO_TRAVEL: "Nessuna trasferta",
  NON_RECOVERABLE_TAXES: "Imposte non recuperabili",
  NON_TRACKED_PINS_HELP_TEXT: "Alcuni prodotti non vengono visualizzati in Garanzia fino a dopo la registrazione. La ricerca corrisponde a una gamma di questi prodotti.",
  NON_TRAVEL: "Spese non relative a trasferte",
  NONE: "Nessuno",
  NORMAL: "NORMALE",
  NOT_EQUAL: "Diverso da",
  NOTIFICATION_ADDED_SUCCESSFULLY: "Notifica aggiunta con successo",
  NOTIFICATION_DELETED_SUCCESSFULLY: "Notifica eliminata con successo",
  NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: "Sequenza di notifica aggiornata correttamente",
  NOTIFICATION_UPDATED_SUCCESSFULLY: "Notifica aggiornata correttamente",
  NOTIFICATIONS: "Notifiche",
  NUMBER_OF_DIAGNOSTICS_OCCURRENCES: "Numero di eventi diagnostici",
  NUMBER_OF_OPEN_PIPS: "{number} PIP aperti",
  NUMBER_OF_REPAIR_OCCURRENCES: "Numero di eventi di riparazione",
  NUMBER_OF_REPLACEMENT_OCCURRENCES: "Numero di eventi di sostituzione",
  OLD_LABOR_RATE: "Precedente tariffa manodopera",
  ON_SHELF: "Giacenze in magazzino",
  ON_SHELF_COST: "Costi aggiunti giacenze in magazzino",
  ONE_ITEM_MUST_BE_SELECTED: "Deve essere selezionato un elemento",
  OPEN: "Aperto",
  OPEN_PART_REQUESTS: "Richieste aperte ricambi",
  OPEN_PART_REQUESTS_WITH_COUNT: "Richieste aperte ricambi ({count})",
  OPEN_PIP_COUNT: "Apri conteggio PIP",
  OPEN_PIP_PROGRAMS: "Registrazione del Programma",
  OPEN_PIPS: "Aprire I PIPs",
  OPEN_PIPS_REPORT: "Aprire il rapporto PIP",
  OPEN_PIPS_TAB: "PIP aperti ({count})",
  OPERATORS_COMPLAINT: "Qual \xE8 la lamentela dell'operatore?",
  OPERATORS_COMPLAINT_IS_REQUIRED: "\xC8 necessario indicarela lamentela dell'operatore",
  OPERATORS_MANUAL_NUMBER: "No. Del Manuale Dell'Operatore",
  OPTION_CODES: "Codici d'opzione",
  OR: "o",
  ORIGINAL_CLAIM_VALUE: "Valore del reclamo originale",
  ORIGINAL_SUBMISSION_DATE: "Data d' invio originale",
  ORIGINALLY_SUBMITTED: "Inviato inizialmente",
  OTHER: "Altro",
  OTHER_AMOUNT_OF_USE: "Altre Ore d\u2019uso",
  OTHER_AMOUNT_OF_USE_REQUIRED: "\xC8 obbligatorio indicare l'altro periodo d' utilizzo",
  OTHER_CREDIT: "Altri Crediti",
  OTHER_CREDIT_1: "Altri Crediti 1",
  OTHER_CREDIT_2: "Altri Crediti 2",
  OTHER_CREDIT_3: "Altri Crediti 3",
  OTHER_CREDIT_ADJUSTMENT: "Regolazione Altri Crediti",
  OTHER_CREDIT_ITEM_DETAILS: "Altri Crediti - {description} ({quantity} {unit})",
  OTHER_CREDIT_TOTAL: "Totale altri crediti",
  OTHER_CREDITS: "Altri Crediti",
  OTHER_CREDITS_WITH_COUNT: "Altri Crediti ({count})",
  OTHER_INSTRUCTIONS: "Altre istruzioni",
  OUTPUT_PIN: "Risultati No. di serie ",
  OVERDUE: "Scaduto",
  OVERRIDE_ACCOUNT: "Override account",
  OVERRIDE_EFFECTIVE_DATE: "Data sostituzione effettiva",
  OVERRIDE_SUGGESTED_ACCOUNT: "Escludi account consigliato",
  OWNERSHIP_STATUS: "Stato propriet\xE0",
  OWNERSHIP_STATUS_IS_REQUIRED: "Lo stato di propriet\xE0 \xE8 obbligatorio",
  PART: "Ricambio",
  PART_1: "Ricambio 1",
  PART_2: "Ricambio 2",
  PART_3: "Ricambio 3",
  PART_4: "Ricambio 4",
  PART_5: "Ricambio 5",
  PART_6: "Ricambio 6",
  PART_7: "Ricambio 7",
  PART_8: "Ricambio 8",
  PART_9: "Ricambio 9",
  PART_10: "Ricambio 10",
  PART_AMONT_OF_USE: "Periodo di utilizzo del ricambio",
  PART_FAMILY: "Famiglia del ricambio",
  PART_ITEM_DETAILS: "Ricambi - {quantity} {description} No. ricambio {partNumber}",
  PART_NUMBER: "No. del ricambio",
  PART_REQUEST: "Richiesta di ricambi",
  PART_REQUEST_NUMBER: "Richiesta di ricambi {rgaNumber}",
  PART_REQUEST_STATUS: "Stato della richiesta di ricambi",
  PART_REQUESTS: "Ricambi Richiesti",
  PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: "Inserire il numero di reclamo, almeno 4 caratteri",
  PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: "La ricerca del reclamo deve contenere almeno 4 caratteri",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: "La ricerca del numero di caso DTAC deve corrispondere al numero completo del caso DTAC, almeno 4 caratteri",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: "Inserire il numero completo del caso DTAC",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: "La ricerca del codice ricambio deve contenere almeno 4 caratteri",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: "Inserire il codice ricambio, almeno 4 caratteri",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: "La ricerca del numero di richiesta del ricambio deve contenere almeno 4 caratteri",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: "Inserire il numero di richiesta del ricambio, almeno 4 caratteri",
  PART_REQUESTS_SEARCH_BY_PIN_ERROR: "La ricerca del No. di Serie deve contenere almeno 4 caratteri",
  PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: "Inserire il No di Serie, almeno 4 caratteri",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: "La ricerca dell'ordine di lavoro deve corrispondere all'ordine di lavoro completo, almeno 2 caratteri",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: "Inserire l'ordine di lavoro completo",
  PART_REQUESTS_UPDATED_SUCCESSFULLY: "Aggiornamento della richiesta del ricambio riuscito",
  PART_RETURN: "Restituzione di ricambi",
  PART_RETURNS: "Restituzioni di ricambi",
  PART_SERIAL_NUMBER: "Numero di Serie del Ricambio",
  PART_SERIAL_NUMBER_IS_REQUIRED: "Il numero di serie del ricambio \xE8 obbligatorio",
  PART_TOTAL: "Totale ricambi",
  PART_TYPE: "Tipo di ricambio",
  PART_USE: "Uso del ricambio",
  PART_VALUE: "Valore del ricambio",
  PARTIAL_DEBIT: "Addebito parziale",
  PARTICIPANT: "Partecipante",
  PARTS: "Ricambi",
  PARTS_ADDITIVE: "Supplemento sui ricambi",
  PARTS_ADJUSTMENT: "Regolazione dei componenti",
  PARTS_COVERAGE_SEARCH: "Ricerca copertura parti",
  PARTS_TEMPLATE: "Modello ricambi",
  PARTS_USE: "Ricambio usato",
  PARTS_USE_IS_REQUIRED: "L'uso del ricambio \xE8 obbligatorio",
  PARTS_WITH_COUNT: "Ricambi ({count})",
  PARTS_WITH_PARENTHESES: "Ricambi",
  PAST_DUE: "Scaduti",
  PAYER_ACCOUNT: "Account pagatore",
  PERCENT_COMPLETE: "Percentuale completata",
  PERCENTAGE: "Percentuale",
  PERCENTAGE_DEBIT: "Debito percentuale",
  PERCENTAGE_SYMBOL: "{percentage}%",
  PERCENTAGE_TO_DEBIT: "Percentuale di addebito",
  PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT: "Per le macchine definitivamente fuori servizio allegare una fotografia della macchina che consenta di accertare che non \xE8 possibile ricostruirla, ripararla o riutilizzarla in futuro. Le macchine definitivamente fuori servizio non dispongono di requisiti per le procedure PIP.",
  PERSON_RESPONSIBLE: "Persona Responsabile",
  PHONE: "Telefono",
  PHONE_REQUIRED: "Telefono richiesto",
  PICTURE: "Immagine",
  PICTURE_REQUEST: "Richiesta di immagini",
  PICTURE_REQUEST_STATUS: "Stato richiesta immagine",
  PICTURE_REQUEST_STATUS_ERROR: "Gli allegati sono pronti per essere inviati con questa richiesta.",
  PIN: "Numero di Serie",
  PIN_CREATED_SUCCESSFULLY: "Creazione No di Serie riuscita",
  PIN_CROSS_REFERENCE: "Controllo incrociato  sul No. di Serie",
  PIN_INVALID: "No.di Serie non valido",
  PIN_IS_REQUIRED: "\xC8 necessario indicare il No. di Serie",
  PIN_REQUIRED: "Il No di Serie \xE8 obbligatorio.",
  PIN_SEARCH: "Ricerca perno",
  PIN_SEARCH_INFORMATION: "Informazioni sulla ricerca dei contatti",
  PIN_TRANSFER_INFORMATION: "Informazioni sul trasferimento dei contatti",
  PINS: "No. di Serie",
  PINS_NOT_REGISTERED: "No. di Serie Non Registrato",
  PIP: "Programma",
  PIP_CODE: "Codice PIP",
  PIP_CODE_CREATED_SUCCESSFULLY: "Creazione richiesta codice PIP riuscita",
  PIP_CODE_REQUEST: "Richiesta codice programma PIP",
  PIP_CODE_REQUEST_APPROVED: "Richiesta codice programma PIP approvata",
  PIP_CODE_REQUEST_REJECTED: "Richiesta codice programma PIP rifiutata",
  PIP_CODE_REQUESTS_WITH_COUNT: "Richieste codice programma PIP ({count})",
  PIP_COMPLETION_STATUS: "Stato Esecuzione Programma",
  PIP_DETAILS: "Dettagli del PIP",
  PIP_HISTORY: "Rapporto storico dei PIP",
  PIP_ID: "Numero PIP",
  PIP_NUMBER: "No. Del Programma",
  PIP_PROGRAM: "Programma PIP",
  PIP_PROGRAM_IS_REQUIRED: "Il programma PIP \xE8 obbligatorio",
  PIP_PROGRAMS: "Programmi PIP",
  PIP_SEARCH: "Cerca il Programma",
  PIP_STATUS: "Stato programma PIP",
  PIP_TYPE: "Tipo programma PIP",
  PIP_TYPES: "Tipi di PIP",
  PIPS: "Programmi di Miglioria",
  PIPS_UNPAID_LABOR_ADDITIVE: "Additivi di manodopera non pagato nei programmi PIP",
  PLAN_DESCRIPTION: "Descrizione del programma",
  PLAN_END_DATE: "Data fine programma",
  PLAN_ENDS: "Fine del programma",
  PLAN_NAME: "Nomeprogramma",
  PLAN_NAME_IS_REQUIRED: "Il nome del programma \xE8 obbligatorio",
  PLAN_NAMES: "Nomi dei programmi",
  PLAN_START_DATE: "Data inizio programma",
  PLAN_STARTS: "Inizio del programma",
  PLANNED_BY: "Progettato da",
  PLANT: "Impianto",
  PLATE_REQUEST_INFORMATION: "Informazioni sulla richiesta della piastra",
  PLEASE_SELECT_A_LEAD_ACCOUNT: "Selezionare un conto principale",
  PLEASE_SELECT_CLAIM_TYPE: "Selezionare il tipo di reclamo",
  POLISH: "Polacco",
  PORTUGUESE: "Portoghese",
  POSTAGE_DELIVERY_DATE: "Data di consegna posta",
  POSTAL_CODE: "Codice Postale",
  POSTAL_CODE_REQUIRED: "Codice postale necessario",
  POSTAL_TRACKING_NUMBER: "Numero di registrazione postale",
  POTENTIAL_RESPONSIBLE_DEALER: "Potenziale dealer responsabile",
  PRE_DELIVERY_INSPECTION: "Ispezione preconsegna",
  PREFERRED_THEME: "Tema preferito",
  PREPARE_AUDIT: "Prepara controllo",
  PREPARED: "Preparato",
  PREPARING_AUDIT_FOR_WITH_DEALER: "Preparazione controllo per {dealer}",
  PREVIOUS_AMOUNT_OF_USE: "Ore d\u2019uso precedente",
  PREVIOUS_INVOICE_NUMBER: "Numero fattura precedente",
  PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: "Il numero della fattura precedente \xE8 obbligatorio",
  PREVIOUS_MONTH: "Mese precedente",
  PRICE: "Prezzo",
  PRICING_SUMMARY: "Riepilogo prezzi",
  PRIMARY_ACTION: "Azione principale",
  PRIMARY_LANGUAGE: "Lingua principale",
  PRINT: "Stampa",
  PRINT_CLAIM: "Stampa reclamo",
  PRINT_REGISTRATION_FORM: "Stampa il formato della registrazione",
  PRINT_REGISTRATION_FORM_MESSAGE: "Prodotto registrato al Primo Proprietario. Volete stampare il modulo d'iscrizione?",
  PRINT_TO_PDF: "Stampa PDF",
  PRIORITY: "Priorit\xE0",
  PRNT_CLM: "Visualizza reclamo",
  PROCESS_DATE: "Data del processo",
  PROCESSED: "Processato",
  PROCESSED_PART_REQUESTS: "Richieste di parti elaborate",
  PROCESSING_STATUS: "Stato del processo",
  PROCESSING_STATUS_DESCRIPTION: "Descrizione stato del processo",
  PRODUCT_DETAILS: "Dettagli prodotti",
  PRODUCT_HIERARCHY: "Gerarchia dei prodotti",
  PRODUCT_INFORMATION: "Informazioni del Prodotto",
  PRODUCT_REGISTERED: "Prodotto registrato",
  PRODUCT_REGISTRATION: "Registrazione dei prodotti",
  PRODUCT_REGISTRATION_PENDED: "La regsitrazione \xE9 in corso",
  PRODUCT_TRACKING: "Ricerca del Prodotto",
  PRODUCTS: "Prodotti",
  PRODUCTS_BY_CUSTOMER: "Prodotti dal cliente",
  PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: "I PIN storici potrebbero mancare dai risultati di ricerca a causa di un problema di connettivit\xE0 di sistema temporaneo",
  PRODUCTS_WITH_COUNT: "Prodotti ({count})",
  PROGRAM: "Programma",
  PROGRAM_DESCRIPTION: "Descrizione programma",
  PROGRAM_IS_REQUIRED: "Il nome del programma \xE8 richiesto.",
  PROGRAM_NAME: "Il nome del programma",
  PROGRAM_NAME_IS_REQUIRED: "Il nome del programma \xE8 richiesto.",
  PROGRAM_NUMBER: "Numero programma",
  PRT: "Ricerca del Prodotto",
  PRTS: "PRT",
  PURCHASE_INFO: "Informazioni sull'acquisto",
  PURCHASE_ORDER: "Ordine di acquisto",
  PURCHASE_ORDER_IS_REQUIRED: "L'ordine di acquisto \xE8 obbligatorio",
  PURCHASER_TYPE: "Tipo D' Aquirente",
  PURCHASER_TYPE_REQUIRED: "Il tipo di acquirente \xE8 necessario",
  PUSH_XML: "Reinvia XML",
  QTY: "Qt\xE0",
  QUALIFY_FOR_EMISSIONS: "Qualifica per emissioni",
  QUANTITY: "Quantit\xE1",
  QUANTITY_1: "Quantit\xE1 1",
  QUANTITY_2: "Quantit\xE1 2",
  QUANTITY_3: "Quantit\xE1 3",
  QUANTITY_4: "Quantit\xE1 4",
  QUANTITY_5: "Quantit\xE1 5",
  QUANTITY_6: "Quantit\xE1 6",
  QUANTITY_7: "Quantit\xE1 7",
  QUANTITY_8: "Quantit\xE1 8",
  QUANTITY_9: "Quantit\xE1 9",
  QUANTITY_10: "Quantit\xE1 10",
  QUERY_MUST_CONTAIN_3_CHARACTERS: "La richiesta deve contenere almeno 3 caratteri",
  QUEST_DESC: "Descrizione discutibile",
  QUESTIONABLE_PART: "Componente discutibile",
  QUEUED: "In coda",
  REASON_FOR_CHANGE: "Ragione del cambio",
  REASON_FOR_DEBIT: "Motivo di addebito",
  REASON_FOR_MISSING_PLATE: "Motivo della mancanza della piastra",
  REASON_FOR_MISSING_PLATE_REQUIRED: "Motivo della mancanza della piastra necessario",
  REASON_FOR_OVERRIDE: "Motivo della sostituzione",
  REASON_FOR_REFUSAL: "Motivo del rifiuto",
  REASON_FOR_RETURN: "Motivi della restituzione",
  REASON_FOR_RETURN_IS_REQUIRED: "I motivi della restituzioni sono obbligatori",
  REASON_FOR_TRANSFER: "Motivo del trasferimento",
  REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: "Il motivo del trasferimento deve contenere caratteri alfanumerici",
  RECIPIENT_DEALER_OR_TCSM: "Destinatario (concessionario o TCSM)",
  RECIPIENT_MAILING: "Destinatario mailing",
  RECONCILE: "Riconcilia",
  RECONCILE_CLAIM: "Riconcilia reclamo",
  RECONCILED: "Riconciliato",
  RECORD_AUDIT: "Registra il controllo",
  RECORD_AUDIT_FOR: "Registrail conntrollo per {dealer}",
  RECORDS_FOUND: "{count, plural, one {{countToDisplay} record trovato} other {Trovati {countToDisplay} record}}",
  RECOVERABLE_TAXES: "Imposte recuperabili",
  RECOVERED: "Recuperato",
  RECOVERED_WITH_MISSED_ADDITIVES: "Recupero con aggiuntivi mancanti",
  RECOVERED_WITHOUT_ADDITIVES: "Recupero senza aggiuntivi di manodopera",
  RECOVERY: "Recupero",
  RED_MUST_BE_LESS_THAN_YELLOW: "Il valore dell'indicatore rosso deve essere inferiore rispetto al valore dell'indicatore giallo",
  REFERENCE_1: "Riferimento 1",
  REFERENCE_2: "Riferimento 2",
  REFERENCE_INFORMATION: "Informazione sul riferimento",
  REFERENCE_NUMBER1: "No.di Referenza 1",
  REFERENCE_NUMBER2: "No.di Referenza 2",
  REGION: "Regione",
  REGISTER: "Registrazione",
  REGISTER_A_PRODUCT_BY_PIN: "Registra un prodotto tramite No. di Serie",
  REGISTER_A_PRODUCT_TO_ADD: "Register Product to add to the Warranty System",
  REGISTER_ANOTHER_PRODUCT: "Registra un altro prodotto",
  REGISTER_PRODUCT: "Registrare il Prodotto",
  REGISTER_PRODUCT_AND_REGISTER_ANOTHER: "Registra il Prodotto e Registra Altro",
  REGISTERED: "Registrato",
  REGISTRATION: "Registrazione",
  REGISTRATION_DATE: "Data di Registrazione",
  REGISTRATION_DATES: "Date di registrazione",
  REGISTRATION_FORM: "Modulo di registrazione",
  REGISTRATION_HISTORY: "Cronologia registrazioni",
  REGISTRATION_NOT_ALLOWED: "Registrazione non ammessa per questo prodotto",
  REGISTRATION_REVIEW: "Revisione della registrazione",
  REGISTRATION_REVIEW_TAB: "Revisione della registrazione ({count})",
  REGISTRATION_STATUS: "Stato  della Registrazione",
  REGISTRATION_STATUS_CANNOT_BE_NEW: "Lo stato della registrazione non pu\xF2 essere nuovo",
  REGISTRATION_STATUS_REQUIRED: "Lo Stato della Registrazione \xE8 richiesto",
  REGISTRATION_SUCCESS: "Registrazione riuscita",
  REGISTRATION_TYPE: "Tipo di registrazione",
  REGISTRATION_TYPE_CANNOT_BE_NEW: "Il tipo di registrazione non pu\xF2 essere nuovo",
  REGISTRATION_TYPE_REQUIRED: "Tipo di registrazione obbligatorio",
  REGISTRATION_UPDATED_SUCCESSFULLY: "Aggiornamento registrazione riuscito",
  REGISTRATIONS_REVIEW: "Revisione delle registrazioni",
  REIMBURSED: "Rimborsato",
  REIMBURSED_AMOUNT: "Importo rimborsato",
  REIMBURSED_PERCENTAGE: "Percentuale rimborso",
  REIMBURSED_PERCENTAGE_INDICATOR: "Indicatore percentuale rimborso",
  REIMBURSEMENT_DETAILS: "Dettagli sul rimborso",
  REIMBURSEMENT_PERCENTAGE: "Percentuale rimborso",
  REIMBURSEMENT_SUMMARY: "Riepilogo rimborso",
  REJECT: "Rifiuta",
  REJECT_LABOR_RATE: "Tariffa manodopera rifiutata",
  REJECT_SPECIAL_ALLOWANCE_CLAIM: "Rifiuta reclamo garanzia speciale concordata",
  REJECTED: "Rifiutato",
  REJECTED_APPEAL: "Appello rifiutato",
  RELATIONSHIP: "Relazione",
  RELATIONSHIP_IS_REQUIRED: "La relazione \xE8 obbligatoria",
  REMOVE_FILTER: "Rimozione del filtro",
  REMOVE_FROM_AUDIT: "Escludi dai Controlli",
  REMOVE_LAYOUT: "Eliminare layout",
  RENTAL_PINS: "PIN di noleggio",
  REPAIR_DATE: "Data di Riparazione",
  REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: "La data di riparazione non pu\xF2 essere precedente rispetto alla data del guasto",
  REPAIR_NUMBER: "No. Della Riparazione",
  REPAIR_NUMBER_IS_REQUIRED: "Il numero della riparazione \xE8 obbligatorio",
  REPAIR_REPLACE_INDICATOR: "Indicatore riparazione/sostituzione",
  REPAIRED: "Riparato",
  REPAIRED_DATE: "Data della riparazione",
  REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: "La data della riparazione non pu\xF2 precedere la data del guasto",
  REPAIRED_DATE_IS_REQUIRED: "La data della riparazione \xE8 obbligatoria",
  REPORT_DATE: "Data del Rapporto",
  REPORT_NUMBER: "No. del Rapporto",
  REPORTS: "Rapporti",
  REQ_ADDL: "Modificare Credito",
  REQUEST_DATE: "Data di richiesta",
  REQUEST_DETAILS: "Request details",
  REQUEST_DUPLICATE_PIN_PLATE: "Richiesta duplicazione targhetta PIN",
  REQUEST_FORM: "Modulo richiesta",
  REQUEST_PIP_CODE: "Richiedi codice PIP",
  REQUEST_STATUS: "Stato della richiesta",
  REQUEST_SUBMITTED: "Richiesta inviata",
  REQUEST_TYPE: "Tipo di richiesta",
  REQUEST_UPDATED_SUCCESSFULLY: "Richiesta aggiornata con successo",
  REQUEST_WARRANTY_CLAIM_DEBIT: "Richiesta addebito reclamo in garanzia",
  REQUESTED: "Richiesta",
  REQUESTED_BY: "Richiesta inviata da",
  REQUESTED_DATE: "Data richiesta",
  REQUESTED_DATES: "Date richieste",
  REQUESTED_DIAGNOSTIC_AMOUNT: "Importo diagnostico desiderata",
  REQUESTED_DIAGNOSTIC_HOURS: "Ore di diagnostica desiderata",
  REQUESTED_LABOR_AMOUNT: "Importo manodopera richiesto",
  REQUESTED_LABOR_HOURS: "Ore manodopera richieste",
  REQUESTED_OTHER_CREDITS: "Altri crediti richiesti",
  REQUESTED_PARTS: "Richieste ricambi",
  REQUESTED_REPAIR_AMOUNT: "Importo di riparazione desiderata",
  REQUESTED_REPAIR_HOURS: "Ore di riparazione desiderata",
  REQUESTED_TRAVEL_TOTAL: "Totale  del viaggio-richiesto",
  REQUESTER_TCSM: "Richiedente (TCSM)",
  REQUESTER_TCSM_REQUIRED: "Richiedente (TCSM) necessario",
  REQUIRED: "*obbligatorio",
  REQUIRED_CRITERIA: "Criteri obbligatori",
  REQUIRED_ITEMS: "Elementi obbligatori",
  RESEND_XML: "Reinvia XML",
  RESET: "Ripristina",
  RESPONDENT_INFORMATION: "Informazioni sul dichiarante",
  RESPONSIBILITY_OF: "Responsabilit\xE0 di",
  RESPONSIBLE_ACCOUNT: "Responsabile del Conto",
  RESPONSIBLE_ACCOUNT_IS_REQUIRED: "\xC8 necessario indicare il conto responsabile",
  RESPONSIBLE_DEALER: "Concessionario Responsabile",
  RET: "Ritornato",
  RETAIL_INSTALL: "Al dettaglio/Installazione",
  RETAIL_INSTALL_DATE: "Al Dettaglio/ Data d'istallazione",
  RETAIL_INSTALL_IS_REQUIRED: "La data di vendita al dettaglio/installazione \xE8 obbligatoria",
  RETAILER_NAME: "Nome del rivenditore",
  RETAILER_NAME_IS_REQUIRED: "Il nome del rivenditore \xE8 obbligatorio",
  RETRY: "riprovare",
  RETURN: "Restituisci",
  RETURN_LABOR_RATE: "Tariffa manodopera di ritorno",
  RETURN_REQUEST: "Richiesta di reso",
  RETURN_SPECIAL_ALLOWANCE_CLAIM: "Rimanda reclamo Garanzia Speciale Concordata",
  RETURN_STATUS: "Stato del reso",
  RETURNED: "Ritornato",
  RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: "La data di restituzione non pu\xF2 precedere la data di consegna",
  RETURNED_DATE_IS_REQUIRED: "La data di restituzione \xE8 obbligatoria",
  REVIEW_DEALER_RECOMMENDATIONS: "Contrassegnare il pin per revisione?",
  REVISE: "Riguarda",
  REVISED: "Rivisto",
  ROLLING_12_CREDIT_AMOUNT: "Importo credito ultimi 12 mesi",
  ROLLING_12_MONTHS: "Ultimi 12 mesi",
  RUN_REPORT: "Esegui rapporto",
  RUSSIAN: "Russo",
  SAP_DOWN_WARNING: "La funzionalit\xE0 del sistema di garanzia \xE8 compromessa. Ci stiamo adoperando per correggerla il pi\xF9 rapidamente possibile. Aggiornare il browser per verificare la disponibilit\xE0 del sistema.",
  SAVE: "Salva",
  SAVE_AS_DRAFT: "Salva in bozza",
  SAVE_AS_NEW_LAYOUT: "Salva come nuovo layout",
  SAVE_AUDIT: "Salva il controllo",
  SAVE_CHANGES: "Salva modifiche",
  SAVE_TO_VALIDATE: "Salva per validare",
  SAVE_VALD: "Salva e valida",
  SAVE_VALIDATE: "Salva e valida",
  SEARCH: "Ricerca",
  SEARCH_BOX_PLACEHOLDER: "Inserire No. di Serie, numero reclamo, caso DTAC o nome cliente",
  SEARCH_BY_CLAIM_TYPE: "Inserire il tipo di reclamo completo",
  SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: "La ricerca del reclamo deve corrispondere al tipo di reclamo completo, tra 4 e 9 caratteri",
  SEARCH_BY_FAILURE_PART_NUMBER: "Inserire il numero completo della parte guasta",
  SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: "La ricerca del reclamo deve corrispondere al numero completo di parte guasta, almeno 4 caratteri",
  SEARCH_BY_WORK_ORDER: "Inserire l'ordine di lavoro, almeno 2 caratteri",
  SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: "La ricerca dell'ordine di lavoro deve contenere tra almeno 2 caratteri",
  SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: "Inserire il numero completo del reclamo",
  SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: "La ricerca del reclamo si basa sul numero completo dello stesso, da 4 a 9 caratteri",
  SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: "Inserire il numero di serie completo del componente",
  SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: "La ricerca del componente deve contenere il numero di serie completo, almeno 1 carattere",
  SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: "Immettere il PIN",
  SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: "Inserire il numero completo del modello",
  SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: "La ricerca del modello si basa sul numero completo dello stesso, da 3 a 12 caratteri",
  SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: "Inserire il No. di Serie, almeno 6 caratteri",
  SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: "La ricerca del PIN deve contenere tra 6 e 17 caratteri",
  SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: "Inserire il numero PIP, almeno 4 caratteri",
  SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: "La ricerca del PIP deve essere compresa tra 4 e 12 caratteri",
  SEARCH_RESULTS_TAB: "Risultati della ricerca ({count})",
  SECOND_SHIP_TO_LOCATION: "Secondo destinatario spedizione",
  SELECT: "Seleziona",
  SELECT_A_RANGE: "Selezionare una gamma",
  SELECT_ALL: "Seleziona tutto",
  SELECT_AUTO_SUBMIT: "Seleziona Inoltro automatico",
  SELECT_BRANCH: "Seleziona filiale",
  SELECT_CLAIM_TYPE: "Selezionare il tipo di reclamo",
  SELECT_CLAIMS: "Seleziona Reclami",
  SELECT_CLAIMS_WITHIN_DATE_RANGE: "Seleziona Reclami compresi nell\u2019intervallo di date",
  SELECT_COLUMNS: "Seleziona Colonne",
  SELECT_COUNTRY: "Selezionare Stato",
  SELECT_CSV_SEPARATOR: "Seleziona Separatore CSV",
  SELECT_DATE_FORMAT: "Seleziona data del  formato ",
  SELECT_DEALERS_AND_STATUS: "Seleziona concessionari e stato",
  SELECT_DECIMAL_FORMAT: "Seleziona formato decimale",
  SELECT_DISPLAY_FORMAT: "Seleziona formato da visualizzazione",
  SELECT_FACTORY: "Seleziona fabbrica",
  SELECT_LANGUAGE: "Seleziona lingua",
  SELECT_LAYOUT: "Seleziona Layout",
  SELECT_NEW_CLAIMS: "Seleziona nuovi Reclami",
  SELECT_PIP_CODE: "Seleziona codice programma PIP",
  SELECT_PLAN_NAMES: "Seleziona nomi dei piani",
  SELECT_SERVICE_INTERVAL_TYPES: "Seleziona tipi intervallo di manutenzione",
  SELECT_SORT_BY: "Seleziona Ordina per",
  SELECT_SORT_DIRECTION: "Seleziona Direzione di ordinamento",
  SELECT_STATE: "Seleziona stato",
  SELECT_STATUS: "Seleziona stato",
  SELECT_TERRITORY: "Selezionare un territorio",
  SELECT_THEME: "Seleziona tema",
  SELECT_TIME_ZONE: "Seleziona fuso orario",
  SELECT_VALUES_TO_APPROVE: "Selezionare i valori da approvare",
  SELECTED_COLUMNS: "Selezionato Colonne",
  SELECTED_FOR_AUDIT: "Selezionato per audit",
  SELECTED_FOR_AUDIT_VSR: "Vedere la soluzione DTAC 221475 per la documentazione di audit richiesta e gli allegati necessari per questo reclamo",
  SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: "La scelta di pi\xF9 conti e tipi di garanzia influisce sulle prestazioni",
  SEND: "Invia",
  SERIAL_NUMBER: "Numero di Serie",
  SERIAL_NUMBER_INVOICE_NUMBER: "Numero di Serie / Numero della Fattura",
  SERVER_TOOK_TOO_LONG_TO_REPLY: "Il server ha impiegato troppo tempo per rispondere e la richiesta \xE8 stata cancellata. Inserire una richiesta pi\xF9 specifica o riprovare pi\xF9 tardi.",
  SERVICE_DATE_IS_REQUIRED: "\xC8 necessario indicare la data della manutenzione",
  SERVICE_INTERVAL: "Intervallo di Servizio",
  SERVICE_INTERVAL_BEGIN_DATE: "Data inizio intervallo di manutenzione",
  SERVICE_INTERVAL_END_DATE: "Data fine intervallo di manutenzione",
  SERVICE_INTERVAL_IS_REQUIRED: "L'intervallo di manutenzione \xE8 obbligatorio",
  SERVICE_INTERVAL_NUMBER: "Numero intervallo di manutenzione",
  SERVICE_INTERVAL_STATUS: "Stato  del Servizio d'intervallo",
  SERVICE_INTERVAL_TYPE: "Tipo di Servizio d'Intervallo",
  SERVICE_INTERVAL_TYPES: "Tipi intervallo di manutenzione",
  SERVICE_PART: "Servizio Parte",
  SERVICE_UNAVAILABLE: "Servizio non disponibile",
  SERVICED: "Manutenzione eseguita",
  SERVICED_DATE_IS_REQUIRED: "La data del servizio \xE8 obbligatoria.",
  SERVICED_IS_REQUIRED: "Il servizio \xE8 richiesto",
  SET_AS_DEFAULT: "Imposta come predefinito",
  SETTINGS: "Le mie impostazioni",
  SETTLED: "Stabilito",
  SETTLEMENT_NO_REGISTRATION: "Accordo, la registrazione non \xE8 necessaria",
  SETUP: "Configurazione",
  SETUP_DATE_IS_REQUIRED: "La data di configurazione \xE8 obbligatoria",
  SETUP_IS_REQUIRED: "La configurazione \xE8 obbligatoria",
  SGST_UTGST: "SGST/UTGST",
  SHIP_TO: "Spedito a",
  SHIPPED: "Spedito",
  SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: "Informazioni di spedizione/Istruzioni speciali",
  SHIPPING_INSTRUCTIONS: "Istruzioni di spedizione",
  SHORT_TEXT: "Testo breve",
  SHORT_TEXT_IS_REQUIRED: "\xE8 richiesto un breve testo",
  SHOW_ALL: "Mostra tutto ({count})",
  SHOW_EXCLUDED: "Mostra esclusi",
  SHOW_MORE: "Mostra di pi\xF9",
  SHOW_MORE_GROUPS: "Mostra {countToDisplay} {count, plural, one {gruppo} other {gruppi}} in pi\xF9",
  SHOW_RED_IF_LESS_THAN: "Rosso se minore di",
  SHOW_REIMBURSED_AMOUNT: "Mostra importo rimborsato",
  SHOW_REIMBURSED_PERCENTAGE: "Mostra percentuale rimborso",
  SHOW_YELLOW_IF_LESS_THAN: "Giallo se minore di",
  SIGN_IN_REQUIRED: "Autenticazione richiesto",
  SIGN_OUT: "Esci",
  SKIP_AUDIT: "Salta audit",
  SKIP_AUDIT_SUCCESS: "Il controllo \xE8 stato saltato e la data di scadenza \xE8 ora in futuro.",
  SOME_PARTS_RETURNED: "Certe Parti Ritornate",
  SORT_BY: "Ordina per",
  SPANISH: "Spagnolo",
  SPECIAL_ALLOWANCE: "Accordo Speciale",
  SPECIAL_ALLOWANCE_CALCULATION: "Calcolo garanzia speciale",
  SPECIAL_ALLOWANCE_CLAIM: "Reclamo garanzia speciale concordata",
  SPECIAL_ALLOWANCE_CLAIM_STATUS: "Stato reclamo garanzia speciale concordata",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: "Stato reclamo garanzia speciale concordata",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: "Stato reclamo garanzia speciale concordata aggiornato",
  SPECIAL_ALLOWANCE_CLAIM_WITH_ID: "Reclamo garanzia speciale concordata - {claimNumber}",
  SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: "Reclamo garanzia speciale concordata ({count})",
  SPECIAL_ALLOWANCE_CONTRIBUTIONS: "Contributi garanzia speciale concordata",
  SPECIAL_ALLOWANCE_DESCRIPTION: "Descrizione garanzia speciale concordata",
  SPECIAL_ALLOWANCE_TYPE: "Tipo D' Autorizzazione Speciale",
  SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: "Il tipo di garanzia speciale \xE8 obbligatorio",
  SPECIAL_INSTRUCTIONS: "Istruzioni speciali",
  SPG: "SPG",
  SPGS: "SPG",
  STANDARD_VIEW: "Vista generale",
  START_AMOUNT_OF_USE: "Periodo di utilizzo iniziale",
  STARTS: "Avviamenti",
  STARTS_WITH: "Inizia con",
  STATE: "Stato",
  STATE_PROVINCE: "Stato/Provincia",
  STATE_PROVINCE_REQUIRED: "Stato/Provincia obbligatorio",
  STATUS: "Stato",
  STATUS_CHANGE_REQUEST: "Richiesta di modifica dello stato",
  STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: "Creazione richiesta modifica di stato riuscita",
  STATUS_FOR: "Stato di  {pin}",
  STATUS_INDICATOR: "Indicatore dello Stato",
  STATUS_REASON: "Motivo della condizione",
  STOLEN_DATE: "Data del furto",
  STORE: "Negozio",
  STORE_IS_REQUIRED: "Il negozio \xE8 obbligatorio",
  STORE_NUMBER_IS_REQUIRED: "Il numero di negozio \xE8 obbligatorio",
  STREET_1: "Via 1",
  STREET_2: "Strada 2",
  SUB: "Invia",
  SUB_CLAIM_TYPE: "Tipo di Reclamo Sostituto",
  SUB_TYPE: "Sottotipo",
  SUBMISSION_DATE: "Data d'inoltro",
  SUBMIT: "Invia",
  SUBMIT_AUDIT: "Invia Controllo",
  SUBMIT_AUDIT_FOR: "Invia audit per {dealer}",
  SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Invia reclamo addebito completo per {claimNumber}",
  SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Invia reclamo addebito parziale per {claimNumber}",
  SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Invia reclamo addebito percentuale per {claimNumber}",
  SUBMIT_REQUEST: "Invia richiesta",
  SUBMITTED: "Inviato",
  SUBMITTED_AVAILABLE_TO_EDIT: "Inviata (Modificabile)",
  SUCCESS: "Successo",
  SUCCESS_MESSAGE_TITLE: "Un'operazione \xE8 riuscita",
  SUCCESS_MESSAGES_TITLE: "Pi\xF9 operazioni sono riuscite",
  SUPPLIER_WARRANTY: "Garanzia del Fornitore",
  SURVEY_QUESTIONS: "Domande del sondaggio",
  SUSPENDED: "Sospeso",
  SWEDISH: "Svedese",
  SYSTEM_SELECTED_CLAIMS: "Reclami selezionati dal sistema",
  SYSTEM_SELECTED_CLAIMS_WITH_COUNT: "Reclami selezionati dal sistema ({count})",
  TABM: "TABM",
  TAX: "Imposte",
  TCSM: "TCSM",
  TECH_ID: "ID del Tecnico",
  TERMINATED: "Terminato",
  TERMINATES: "Termina",
  TERRITORY: "Territorio",
  TEST: "Test",
  TEST_RESULTS_CODE: "Codice del Risultato del Test",
  THEME: "Tema",
  TIME_LIMIT: "Limite di tempo",
  TIME_ZONE: "Fuso orario",
  TITLE: "Titolo",
  TITLE_IS_REQUIRED: "Titolo \xE8 obbligatorio",
  TO: "a",
  TODAY: "Oggi",
  TOO_MANY_RESULTS: "La richiesta ha restituito troppi risultati. Limitare i termini di ricerca e riprovare.",
  TOTAL: "Totale",
  TOTAL_AMOUNT: "Importo Totale",
  TOTAL_APPROVED: "Totale approvato",
  TOTAL_APPROVED_CLAIM_VALUE: "Tot. valore reclamo approvato",
  TOTAL_APPROVED_INCLUDING_TAXES: "Totale approvato tasse incluse",
  TOTAL_APPROVED_WITHOUT_ADDITIVES: "Totale reclami approvati senza additivi",
  TOTAL_CONTRIBUTION: "Contributo totale",
  TOTAL_REIMBURSED: "Totale rimborsato",
  TOTAL_REIMBURSED_WITH_CURRENCY: "Totale rimborsato ({currency})",
  TOTAL_REQUESTED: "Totale richiesto",
  TOTAL_REQUESTED_CLAIM_VALUE: "Tot. valore reclamo richiesto",
  TOTAL_UNPAID: "Totale non pagato",
  TRACKING_NUMBER: "Numero ID ricerca",
  TRANSFER: "Trasferimento",
  TRANSFER_APPROVALS: "Approvazioni di trasferimento",
  TRANSFER_APPROVALS_TAB: "Approvazioni di trasferimento ({count})",
  TRANSFER_CREATED: "Trasferimento creato",
  TRANSFER_DEALER_RECOMMENDATIONS: "Trasferire il pin all'altro dealer?",
  TRANSFER_UPDATED_SUCCESSFULLY: "Trasferimento aggiornato correttamente",
  TRANSFERS: "Trasferimenti",
  TRAVEL: "Viaggio",
  TURKISH: "Turco",
  TWO_PERCENT_WITHHOLD_VALUE: "2% trattenere valore",
  TYPE: "Tipo",
  TYPES: "Tipi",
  UNABLE_TO_CONTACT_THE_SERVER: "Impossibile contattare il server",
  UNABLE_TO_LOAD_CUSTOMER_DETAILS: "Impossibile caricare le informazioni sul cliente",
  UNDO: "Annulla",
  UNDO_REGISTRATION: "Annulla registrazione",
  UNDO_REGISTRATION_SUCCESSFULL: "Annullamento registrazione riuscito",
  UNIT: "Unit\xE1",
  UNIT_1: "Unit\xE1 1",
  UNIT_2: "Unit\xE1 2",
  UNIT_3: "Unit\xE1 3",
  UNIT_OF_MEASURE: "Unit\xE1 di Misura",
  UNPAID_LABOR: "Manodopera non pagata",
  UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: "Additivi di manodopera non pagati \u2013 Esclusi PIP",
  UNPAID_LABOR_ADDITIVES_PIPS: "Additivi di manodopera non pagati \u2013 PIP",
  UNPAID_OTHER_CREDITS: "Altri crediti non pagati",
  UNPAID_PARTS: "Parti non pagate",
  UNPAID_PARTS_ADDITIVE: "Additivi Ricambi non pagati",
  UNPAID_TRAVEL: "Trasferta non pagata",
  UNSUB: "Modifica",
  UNSUBMIT_CLAIM: "Modifica Reclamo",
  UPDATE_CUSTOMER_INFORMATION: "Aggiornare le Info. Del Cliente",
  UPDATE_LABOR_RATES: "Aggiorna tariffe manodopera",
  UPDATE_LAYOUT: "Aggiornare il layout",
  UPDATE_MACHINE_STATUS: "Aggiornare lo stato della macchine",
  UPDATE_MACHINE_STATUS_HISTORY: "Cronologia aggiornamenti stato della macchina",
  UPDATE_REGISTRATION: "Aggiorna registrazione",
  UPDATE_SELECTED: "Aggiorna selezionati",
  UPDATED: "Aggiornato",
  UPDATED_BY: "Aggiornato da",
  UPLOAD_DOCUMENT: "Carica documento",
  UPTIME_ASSURANCE: "Affidabilit\xE0",
  USEFUL_LINKS: "Collegamenti utili",
  USER: "utente",
  USER_PREFERENCES_UPDATED: "Preferenze dell'utente aggiornate",
  USER_SELECTED: "Selezione utente",
  USER_SELECTED_CLAIMS_WITH_COUNT: "Reclami selezionati dall'utente ({count})",
  USERS_INFORMATION: "Informazioni utente",
  VALIDATE: "Convalida",
  VALIDATE_CLAIM: "Convalida reclamo",
  VALUE: "Valore",
  VALUE_OF_REPAIR: "Valore della riparazione",
  VIEW_CLAIM: "Visualizza reclamo",
  VIEW_DETAILS: "Visualizza dettagli",
  VIEW_OPEN_PIPS: "Visualizza PIP aperti",
  VIEW_PIP: "Visualizza PIP",
  VIEW_PRODUCTS: "Visualizza prodotti",
  VIEW_PRODUCTS_AND_UPDATE_INFO: "Visualizza prodotti e informazioni sull'aggiornamento",
  VIEW_UPDATE: "Visualizza/Aggiorna",
  VSR_MESSAGES: "Messaggi VSR",
  WAITING_FOR_DLR_INV: "In attesa della fatt. dal Conc.",
  WAITING_FOR_INVOICE: "In attesa della fattura ({count, number})",
  WAITING_SINCE: "In attesa da",
  WARNING_MESSAGE_TITLE: "\xC8 stato inviato un messaggio d' avvertenza",
  WARNING_MESSAGES: "Messaggi di avvertenza",
  WARNING_MESSAGES_TITLE: "Sono stati inviati messaggi multipli d' avvertenza",
  WARRANTY: "Garanzia",
  WARRANTY_ADMIN: "Amministratore Garanzia",
  WARRANTY_CLAIM_TYPE: "Tipo di reclamo in garanzia",
  WARRANTY_COVERAGE: "Copertura della Garanzia",
  WARRANTY_EXPIRATION: "Scadenza della garanzia",
  WARRANTY_TYPE: "Tipo di garanzia",
  WARRANTY_TYPES: "Tipi di garanzia",
  WEAR_PARTS: "Parti di usura",
  WEAR_PARTS_COVERAGE: "Copertura parti di usura",
  WELCOME: "Benvenuto",
  WIP: "In fase di preparazione",
  WITH_ADDITIVES: "Con supplementi",
  WITNESS_FIRST_NAME: "Nome testimone",
  WITNESS_LAST_NAME: "Cognome testimone",
  WORK_ORDER: "Ordine di lavoro",
  WORK_ORDER_NUMBER: "Numero ordine di lavoro",
  WORK_ORDER_ONE: "Ordine di lavoro 1",
  WORK_ORDER_ONE_IS_REQUIRED: "L'ordine di lavoro 1 \xE8 obbligatorio",
  WORK_ORDER_THREE: "Ordine di lavoro 3",
  WORK_ORDER_THREE_IS_REQUIRED: "L'ordine di lavoro 3 \xE8 obbligatorio",
  WORK_ORDER_TWO: "Ordine di lavoro 2",
  WORK_REPAIR_ORDER: "Ordine lavoro di riparazione",
  YES: "Si",
  YES_LOWERCASE: "S\xEC"
});